import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";

@Component({
    selector: 'confirm-dialog',
    templateUrl: 'confirm.component.html',
})
export class ConfirmDialog {

    //@Inject(MAT_DIALOG_DATA) public data: any
    constructor(public dialogRef: MatDialogRef<ConfirmDialog>) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/dialogs/confirm/confirm.component.ts